import Vue from 'vue'
import { Formatter } from '@/filters/formatter'
Vue.filter('ago', Formatter.ago)
